import * as I from "immutable";
import moment from "moment";

import { Action, actionCreators } from "../actions";

const LOG_MAX_SIZE = 100;
type EventType =
    | typeof actionCreators.onOnline.type
    | typeof actionCreators.onOffline.type
    | typeof actionCreators.onTyping.type
    | typeof actionCreators.checkIfTypingStuck.type;

const initialStore = I.Record({
    eventLog: I.List<{ date: Date; type: EventType; roomId?: string; message?: string }>(),
})();
type Store = typeof initialStore;

export function update(store = initialStore, action: Action): Store {
    switch (action.type) {
        case actionCreators.onLogout.type:
        case actionCreators.onWrongToken.type: {
            return initialStore;
        }
        case actionCreators.onOffline.type:
        case actionCreators.onOnline.type: {
            return store.merge({
                eventLog: addEventLog(store.eventLog, action.type),
            });
        }
        case actionCreators.onTyping.type: {
            const { room_id: roomId, user_ids: userIds } = action.payload;
            return store.merge({
                eventLog: addEventLog(store.eventLog, action.type, {
                    roomId,
                    message: `${userIds.length} user(s)`,
                }),
            });
        }
        case actionCreators.checkIfTypingStuck.type: {
            const { roomId } = action.payload;
            return store.merge({
                eventLog: addEventLog(store.eventLog, action.type, { roomId }),
            });
        }
        default: {
            return store;
        }
    }
}

function addEventLog(
    eventLog: Store["eventLog"],
    type: EventType,
    { roomId, message }: { roomId?: string; message?: string } = {}
) {
    const date = new Date();
    return cappedEventLog(eventLog).push({ date, type, roomId, message });
}

function cappedEventLog(eventLog: Store["eventLog"]) {
    return eventLog.takeLast(LOG_MAX_SIZE - 10);
}

function eventLogToStr(eventLog: Store["eventLog"]) {
    let oldDate: Date | undefined = undefined;
    return eventLog
        .map(({ date, type, message }) => {
            const since = oldDate ? ` (after ${moment(date).from(oldDate, true)})` : "";
            oldDate = date;
            return `${type}: ${message ? `[${message}] ` : ""}${moment(date).fromNow()}${since}`;
        })
        .join("\n");
}

export type OuterStore = { debugLog: Store };

export function getTypingButLog(store: OuterStore, roomId: string) {
    return eventLogToStr(
        store.debugLog.eventLog.filter(
            x =>
                x.type === "ON_ONLINE" ||
                x.type === "ON_OFFLINE" ||
                ((x.type === "ON_TYPING" || x.type === "CHECK_IF_TYPING_STUCK") &&
                    x.roomId === roomId)
        )
    );
}
